import './App.css';
//import FaceScene from './Components/';
import SociosphereHomepage from './Components/Home/home';
import { Navbar, Footer } from './Components/Home/layout';

function App() {
  return (
    <>
            <Navbar/>
             <SociosphereHomepage /> 
            <Footer/>
        </>
  );
}

export default App;
